module.exports = __webpack_public_path__ + "img/barChart1.79e6bf28.svg";